// Typelizer digest 4a3a476be106887d818ede408e3ffa30
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/ledger/question_reminder */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/ledger/question_reminder', {}, options),
    method: 'post',
  }),
}
